import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=60d201d6&scoped=true&"
import script from "./ContactDialog.vue?vue&type=script&lang=js&"
export * from "./ContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=60d201d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d201d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d201d6')) {
      api.createRecord('60d201d6', component.options)
    } else {
      api.reload('60d201d6', component.options)
    }
    module.hot.accept("./ContactDialog.vue?vue&type=template&id=60d201d6&scoped=true&", function () {
      api.rerender('60d201d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/ContactDialog.vue"
export default component.exports